import React, { Component } from "react";
import { connect } from "react-redux";
import { updateDrumWidthSelection } from "../actions/";

class DrumWidthSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultDrumWidth: [],
      show: false
    };
    this.handleOnchange = this.handleOnchange.bind(this);
  }

  handleOnchange = selected => {
    this.props.onDrumWidthSelect(JSON.parse(selected.target.value));
  };

  componentDidUpdate(previousProps) {
    if (
      previousProps.winchType !== this.props.winchType ||
      previousProps.mType !== this.props.mType ||
      previousProps.previewStatus !== this.props.previewStatus
    ) {
      if (this.props.winchType.orderCode) {
        this.setState({
          show: true
        });
      }
      if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "01"
      ) {
        this.setState({
          defaultDrumWidth: [
            {
              value: "152,4",
              unit: "mm",
              orderCode: "0",
              weight: 0,
              maxRopeCapacity: "60 m",
              ropeDiameter: "8 mm",
              drumType: "standardDrum"
            }
          ]
        });
        this.props.onDrumWidthSelect({
          value: "152,4",
          unit: "mm",
          orderCode: "0",
          weight: 0,
          maxRopeCapacity: "60 m",
          ropeDiameter: "8 mm",
          drumType: "standardDrum"
        });
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "01"
      ) {
        this.setState({
          defaultDrumWidth: [
            {
              value: 6.0,
              unit: "inch",
              orderCode: "0",
              weight: 0,
              maxRopeCapacity: "132 ft",
              ropeDiameter: '3/8 "',
              drumType: "standardDrum"
            }
          ]
        });
        this.props.onDrumWidthSelect({
          value: 6.0,
          unit: "inch",
          orderCode: "0",
          weight: 0,
          maxRopeCapacity: "132 ft",
          ropeDiameter: '3/8 "',
          drumType: "standardDrum"
        });
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "02"
      ) {
        this.setState({
          defaultDrumWidth: [
            {
              value: "179,2",
              unit: "mm",
              orderCode: "0",
              weight: 0,
              maxRopeCapacity: "62 m",
              ropeDiameter: "10 mm",
              drumType: "standardDrum"
            }
          ]
        });
        this.props.onDrumWidthSelect({
          value: "179,2",
          unit: "mm",
          orderCode: "0",
          weight: 0,
          maxRopeCapacity: "62 m",
          ropeDiameter: "10 mm",
          drumType: "standardDrum"
        });
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "02"
      ) {
        this.setState({
          defaultDrumWidth: [
            {
              value: 7.0,
              unit: "inch",
              orderCode: "0",
              weight: 0,
              maxRopeCapacity: "141 ft",
              ropeDiameter: '7/16 "',
              drumType: "standardDrum"
            }
          ]
        });
        this.props.onDrumWidthSelect({
          value: 7.0,
          unit: "inch",
          orderCode: "0",
          weight: 0,
          maxRopeCapacity: "141 ft",
          ropeDiameter: '7/16 "',
          drumType: "standardDrum"
        });
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "04"
      ) {
        this.setState(
          {
            defaultDrumWidth: [
              {
                value: "228,5",
                unit: "mm",
                orderCode: "0",
                weight: 0,
                maxRopeCapacity: "87 m",
                ropeDiameter: "13 mm",
                drumType: "standardDrum"
              },
              {
                value: "309,4",
                unit: "mm",
                orderCode: "1",
                weight: 20,
                maxRopeCapacity: "120 m",
                ropeDiameter: "13 mm",
                drumType: "largeDrum"
              }
            ]
          },
          () => {
            if (this.props.drumWidth) {
              this.state.defaultDrumWidth.map((drum, index) => {
                if (drum.orderCode === this.props.drumWidth.orderCode) {
                  return this.props.onDrumWidthSelect(drum);
                }
              });
            } else {
              this.props.onDrumWidthSelect({
                value: "228,5",
                unit: "mm",
                orderCode: "0",
                weight: 0,
                maxRopeCapacity: "87 m",
                ropeDiameter: "13 mm",
                drumType: "standardDrum"
              });
            }
          }
        );
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "04"
      ) {
        this.setState(
          {
            defaultDrumWidth: [
              {
                value: 9.0,
                unit: "inch",
                orderCode: "0",
                weight: 0,
                maxRopeCapacity: "204 ft",
                ropeDiameter: '9/16 "',
                drumType: "standardDrum"
              },
              {
                value: 12.2,
                unit: "inch",
                orderCode: "1",
                weight: 44,
                maxRopeCapacity: "364 ft",
                ropeDiameter: '9/16 "',
                drumType: "largeDrum"
              }
            ]
          },
          () => {
            if (this.props.drumWidth) {
              this.state.defaultDrumWidth.map((drum, index) => {
                if (drum.orderCode === this.props.drumWidth.orderCode) {
                  this.props.onDrumWidthSelect(drum);
                }
              });
            } else {
              this.props.onDrumWidthSelect({
                value: 9.0,
                unit: "inch",
                orderCode: "0",
                weight: 0,
                maxRopeCapacity: "204 ft",
                ropeDiameter: '9/16 "',
                drumType: "standardDrum"
              });
            }
          }
        );
      } else if (
        this.props.mType === "metric" &&
        this.props.winchType.orderCode === "05"
      ) {
        this.setState({
          defaultDrumWidth: [
            {
              value: "309,5",
              unit: "mm",
              orderCode: "0",
              weight: 0,
              maxRopeCapacity: "87 m",
              ropeDiameter: "14 mm",
              drumType: "standardDrum"
            }
          ]
        });
        this.props.onDrumWidthSelect({
          value: "309.5",
          unit: "mm",
          orderCode: "0",
          weight: 0,
          maxRopeCapacity: "87 m",
          ropeDiameter: "14 mm",
          drumType: "standardDrum"
        });
      } else if (
        this.props.mType === "imperial" &&
        this.props.winchType.orderCode === "05"
      ) {
        this.setState({
          defaultDrumWidth: [
            {
              value: 12.2,
              unit: "inch",
              orderCode: "0",
              weight: 0,
              maxRopeCapacity: "256 ft",
              ropeDiameter: '5/8 "',
              drumType: "standardDrum"
            }
          ]
        });
        this.props.onDrumWidthSelect({
          value: 12.2,
          unit: "inch",
          orderCode: "0",
          weight: 0,
          maxRopeCapacity: "256 ft",
          ropeDiameter: '5/8 "',
          drumType: "standardDrum"
        });
      }
    }
  }

  render() {
    var drums = this.state.defaultDrumWidth.map((drum, index) => {
      return (
        <div className="col-md-6" key={index}>
          <label>
            <input
              type="radio"
              value={JSON.stringify(drum)}
              name="drum_width"
              defaultChecked={
                this.props.drumWidth.orderCode
                  ? this.props.drumWidth.orderCode === drum.orderCode
                  : index === 0
              }
            />{" "}
            {drum.value + " " + drum.unit}
          </label>
          <br />
          <p>
            The maximum rope capacity of this drum is {drum.maxRopeCapacity}{" "}
            based on the recommended rope diameter of {drum.ropeDiameter}
          </p>
        </div>
      );
    });
    return (
      <div>
        {this.state.show && (
          <div>
            <div className="field-top">Drum width</div>
            <div className="selection-body">
              <p>The width of the drum is</p>
              <div className="row" onChange={this.handleOnchange}>
                {drums}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    mType: state.mType,
    winchType: state.winchType,
    drumWidth: state.drumWidth,
    previewStatus: state.previewStatus
  };
};

const mapActionsToProps = {
  onDrumWidthSelect: updateDrumWidthSelection
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(DrumWidthSelection);



// WEBPACK FOOTER //
// ./src/components/drumWidthSelection.js